import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import InputText from "../../shared/input/new/InputText"
import PageTopTitle from "../../shared/PageTopTitle"
import { deleteProject, getCompanyVergiNo, setIsSearchCompany, setSearchCompany, setSelectedLoadOwner, updateCompanyProject } from "../../../features/isOrtaklari/isOrtaklariSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 25;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-block: 20px;
        border-radius: 10px;
        
        .detail-container{
            display: flex;
            flex-direction: column;
            padding: 20px;
            width: 100%;
            .detail-content{
                width: 80%;
                margin-block: 5px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                padding-block: 20px;
                p{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                }
                span{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                }
                .load-owners{
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    gap: 10px;
                    .owner-item{
                        display: flex;
                        align-items: center;
                        gap: 20px;
                    }
                }
            }
            .new-content{
                width: 80%;
                margin: 0 auto;
                display: flex;
                flex-direction: column;
                gap: 20px;
                .info{
                    color: ${({ theme }) => theme.mainTextColor};
                    text-decoration: none;
                    margin-top: 0px !important;
                    span{
                        text-decoration: underline;
                        color: var(--color-main);
                    }
                }
                .input-item{
                    display: flex;
                    align-items: center;
                    gap: 20px;
                }
                p{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    cursor: pointer;
                    margin-top: 20px;
                }
            }
            .delete{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                color: var(--color-main);
                text-decoration: underline;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
        .btn-container{
            display: flex;
            align-items: center;
            margin-top: 25px;
            width: 100%;
            justify-content: center;
            gap: 15px;
        }
    }
    .owners{
        align-items: flex-start !important;
        
    }
    .error{
        font-size: 12px;
        color: var(--color-main);
        font-weight: var(--font-weight-lg);
    }
`
    
const ProjeDetayModal = () => {
    const { selectedProject, searchCompany, isSearchCompany } = useSelector(state => state.isOrtaklari)
    const {modalLocation } = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const [projectName, setProjectName] = useState(selectedProject?.projectName)
    const [newLoadOwners, setNewLoadOwners] = useState("")
    const [showNewLoadOwner, setShowNewLoadOwner] = useState(false)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        const body = {
            id: selectedProject.id,
            companyProjectName: projectName,
            digitalLogisticId: selectedProject.digitalLogisticId,
            taxNo: newLoadOwners,

            yetkiliUserName: "",
            yetkiliMail: "",
            yetkiliPhoneNumber: "",
            firmaName: "",
        }
        dispatch(updateCompanyProject(body))
        setNewLoadOwners("")
    }

  return (
    <Container>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <PageTopTitle isDiffPage title={"Görmesi İstenen Yükveren / Lojistikçi Ekle"} />
            <div className="detail-container">
               <div className="detail-content">
                    <InputText data={projectName} setData={(e) => setProjectName(e.target.value)} labelText="Proje Adı" name={"projectName"} inputWidth={"300px"} />
               </div>

               <div className="detail-content">
                    <p>Dijital Lojistikçi / Nakliyeci / Kooperatif: </p>
                    <span>{selectedProject?.digitalLogisticCompanyName}</span>
                </div>

                <div className="detail-content owners">
                    <p>Yükveren Müşteri:</p>
                    <div className="load-owners">
                        {selectedProject?.loadOwnerCompanyDtos?.map((item) => (
                            <div className="owner-item">
                                <span>{item?.loadOwnerCompanyName}</span>
                                <div onClick={() => {dispatch(showNestedModal("deleteLoadOwner")); dispatch(setSelectedLoadOwner(item))}} className="delete">Sil</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="new-content">
                    <p>Projeyi Görmesi İstenen Yükveren Müşteri Ekle</p>
                    {/* {showNewLoadOwner &&  */}
                        <div className="input-item">
                            <InputText max={11} data={newLoadOwners} setData={(e) => setNewLoadOwners(e.target.value)} labelText={"Vergi Numarası"} name={"taxNo"} inputWidth={"300px"} />
                            <div className="delete" onClick={()=> dispatch(getCompanyVergiNo(newLoadOwners))}>Sorgula</div>
                            {/* <div className="delete" onClick={() => setShowNewLoadOwner(false)}>Sil</div> */}
                        </div>
                    {/* } */}
                    {!searchCompany?.id && isSearchCompany && <p className="info">Bu vergi numarasıyla kayıtlı bir üyelik bulunmuyor. Üyelik oluşturmak için <span onClick={() => dispatch(showModal("yukVerenKayit"))}>tıkla!</span></p> }
                    {searchCompany?.id && isSearchCompany && <p className="info">Bu vergi numarasıyla kayıtlı bir üyelik bulunuyor. Kaydet butonuna basarak projeye davet edebilirsiniz.</p> }
                </div>
                
                <div className="btn-container">
                    <Button width="160px" handleClick={handleSubmit} padding="10px" background="#fff" color={"#E85446"}>Güncelle / Kaydet</Button>
                    <Button width="160px" handleClick={() => {dispatch(deleteProject(selectedProject.id))}} padding="10px" background="#fff" color={"#E85446"}>Projeyi Sil</Button>
                    <Button width="160px" handleClick={() => {dispatch(showModal(null)); dispatch(setSearchCompany(null)); dispatch(setIsSearchCompany(false))}} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default ProjeDetayModal